// extracted by mini-css-extract-plugin
export default {"modalWrapper":"ModalWrapper_modalWrapper__F76fI","closeModalX":"ModalWrapper_closeModalX__sOIgB","modalContainer":"ModalWrapper_modalContainer__ru9gi"};